<template>
    <div>
        <el-dialog
                :title="title+typeList[inputForm.menuType]"
                :close-on-click-modal="false"
                :visible.sync="visible" class="dialogForm">
            <el-form size="small" :model="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"
                     :disabled="method==='view'" :rules="dataRule" ref="inputForm" @keyup.enter.native="doSubmit()"
                     label-width="120px" @submit.native.prevent>
                <el-form-item label="菜单类型" prop="menuType">
                    <el-radio-group v-model="inputForm.menuType">
                        <el-radio v-for="(type, index) in typeList" :label="index.toString()" :key="index">{{ type }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="上级菜单" prop="parentId">
                    <SelectTree
                            ref="menuParentTree"
                            :props="{
                value: 'id',             // ID字段名
                label: 'name',         // 显示名称
                children: 'children'    // 子级字段名
              }"
                            :data="menuList"
                            :value="inputForm.parentId"
                            :clearable="true"
                            :accordion="true"
                            @getValue="(value) => {inputForm.parentId=value}"/>
                </el-form-item>
                <el-form-item :label="typeList[inputForm.menuType] + '名称'" prop="name">
                    <el-input maxlength="10" v-model="inputForm.name"
                              :placeholder="typeList[inputForm.menuType] + '名称(限10字)'"></el-input>
                </el-form-item>
                <el-form-item label="菜单分类" prop="menuStyle" v-if="inputForm.menuType === '0'">
                    <el-radio-group v-model="inputForm.menuStyle" @input="menuStyleChange">
                        <el-radio :label="item.value" :key="item.value" v-for="item in $dictUtils.getDictList('menuStyle')">{{item.label}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="关联业务模板" prop="menuMetadataConfigId" v-if="inputForm.menuStyle == 1 && inputForm.menuType === '0'">
                    <el-select v-model="inputForm.menuMetadataConfigId" placeholder="请选择" filterable class="w100" @change="changeConfig">
                        <el-option
                                v-for="item in menuMetadataOpt"
                                :key="item.id"
                                :label="item.tableName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="链接地址" prop="href">
                    <el-input maxlength="1000" v-model="inputForm.href" placeholder="请填写路由路径或者超链接" :disabled="inputForm.menuStyle == '1'"></el-input>
                </el-form-item>
                <el-form-item v-if="inputForm.menuType === '0'" label="链接类型" prop="target">
                    <el-select v-model="inputForm.target" placeholder="如果是路由路径请留空白，http链接或者外部链接请选择iframe" clearable
                               style="width: 100%;">
                        <el-option
                                v-for="item in [{label: 'iframe', value: 'iframe'}]"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="inputForm.menuType === '0'" label="菜单图标" prop="icon">
                    <el-input v-model="inputForm.icon" clearable @focus="selectIcon" placeholder="菜单图标名称"></el-input>
                </el-form-item>
                <el-form-item v-if="inputForm.menuType === '0'" label="所属系统" prop="owningSystem">
                    <el-select v-model="inputForm.owningSystem" style="width: 100%" clearable placeholder="请选择所属系统">
                        <el-option
                            v-for="item in $dictUtils.getDictList('sys_menu_local_system')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="inputForm.menuType === '0'" label="可见" prop="isShow">
                    <el-radio-group v-model="inputForm.isShow">
                        <el-radio label="0">显示</el-radio>
                        <el-radio label="1">隐藏</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否常用功能" prop="menuCommonUse" v-if="inputForm.menuType === '0'">
                    <el-radio-group v-model="inputForm.menuCommonUse">
                        <el-radio label="0">是</el-radio>
                        <el-radio label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="仅管理员可见" prop="menuSys">
                    <el-radio-group v-model="inputForm.menuSys">
                        <el-radio label="0">是</el-radio>
                        <el-radio label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="授权标识"
                              prop="permission">
                    <el-input v-model="inputForm.permission" maxlength="50"
                              placeholder="多个用逗号分隔, 如: user:list,user:create"></el-input>
                </el-form-item>
                <el-form-item label="排序号" prop="sort">
                    <el-input-number v-model="inputForm.sort" controls-position="right" :min="0"
                                     label="排序号"></el-input-number>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input v-model="inputForm.remarks" maxlength="200" type="textarea"
                              :rows="2" placeholder="备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="visible = false">{{method == 'view' ? '关闭' : '取消'}}</el-button>
                <el-button size="small" v-if="method != 'view'" type="primary" @click="doSubmit()" v-noMoreClick>保存</el-button>
            </div>
        </el-dialog>
        <Icon ref="icon" @getValue="value => inputForm.icon = value"></Icon>
    </div>
</template>

<script>
    import Icon from '@/components/icon'
    import SelectTree from '@/components/treeSelect/treeSelect.vue'

    export default {
        data() {
            const validateUrl = (rule, value, callback) => {
                if (this.inputForm.menuType === 0 && !/\S/.test(value)) {
                    callback(new Error('菜单URL不能为空'))
                } else {
                    callback()
                }
            }
            return {
                visible: false,
                loading: false,
                method: '',
                title: '新增',
                typeList: ['菜单', '按钮'],
                menuList: [],
                menuListTreeProps: {
                    label: 'name',
                    children: 'children'
                },
                inputForm: {
                    id: '', // 菜单id
                    name: '',  // 菜单名称
                    menuStyle: '0',  // 菜单分类
                    parentId: '1',  // 上级菜单id
                    menuMetadataConfigId: null,  // 业务模板
                    href: '',  // 链接地址
                    target: '',  // 链接类型
                    owningSystem:'',//菜单所属系统
                    icon: '',  // 菜单图标
                    sort: 1,  // 排序号
                    isShow: '0',  // 可见
                    menuCommonUse: '1',  // 是否常用
                    menuSys: '1',  // 管理员可见
                    menuType: '0',  // 菜单类型
                    remarks: '',  // 备注
                    permission: '',  // 授权标识
                },
                menuMetadataOpt: [],
                dataRule: {
                    name: [
                        {required: true, message: '名称不能为空', trigger: 'blur'}
                    ],
                    url: [
                        {validator: validateUrl, trigger: 'blur'}
                    ],
                    menuMetadataConfigId: [
                        {required: true, message: '关联业务模板不能为空', trigger: 'change'}
                    ],
                    owningSystem: [
                        {required: true, message: '请选择所属系统', trigger: 'change'}
                    ],
                }
            }
        },
        components: {
            SelectTree,
            Icon
        },
        methods: {
            init(method, obj, row) {
                this.getMenuMetadataOpt()
                this.method = method
                this.inputForm.id = obj.id
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'addChild') {
                    this.title = '添加下级'
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                this.$axios(this.api.user.sysnewmenuList, {}, 'get').then(data => {
                    this.menuList = data.data
                    this.recursion(this.menuList)
                    this.inputForm.parentId = ''
                    this.inputForm.parentName = ''
                }).then(() => {
                    this.visible = true
                    this.$nextTick(() => {
                        this.$refs.menuParentTree.clearHandle()
                        this.$refs['inputForm'].resetFields()
                        this.inputForm.href = ''
                        this.inputForm.parentId = obj.parent.id
                        this.inputForm.parentName = obj.parent.name
                    })
                }).then(() => {
                    if (method === 'edit' || method === 'view') { // 修改或者查看
                        this.inputForm.href = ''
                        this.inputForm = this.recover(this.inputForm, row)
                    }
                })
            },
            // 递归
            recursion(list) {
                list.map(item => {
                    if (item.menuStyle == '1') {
                        this.$set(item, 'disabled', true)
                    }
                    if (item.children.length) {
                        this.recursion(item.children)
                    }
                })
            },
            // 选择菜单分类
            menuStyleChange() {
                this.inputForm.menuMetadataConfigId = null
            },
            // 选择业务配置
            changeConfig(val) {
                this.$set(this.inputForm, 'href', '/dyygCollect/library/list?id=' + val)
            },
            // 获取业务配置
            getMenuMetadataOpt() {
                this.$axios(this.api.metadata.metadatatableconfigList, {size: 99999999, current: 1},'post').then(data => {
                    if (data && data.status) {
                        this.menuMetadataOpt = data.data.records
                    }
                })
            },
            selectIcon() {
                this.$refs.icon.visible = true
            },
            // 表单提交
            doSubmit() {
                this.$refs['inputForm'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        let api = '', type = '';
                        if (this.method === 'add' || this.method === 'addChild') {  // 新增
                            api = this.api.user.sysnewmenuSave;
                            type = 'post';
                        } else if (this.method === 'edit') {  // 修改
                            api = this.api.user.sysnewmenuUpdateById
                            type = 'put';
                        }
                        if (!this.inputForm.parentId) {
                            this.inputForm.parentId = '1'
                        }
                        if (this.inputForm.menuType == '1') {
                            this.inputForm.target = '';
                            this.inputForm.icon = '';
                            this.inputForm.isShow = '0';
                        }
                      console.log(this.inputForm)
                      if (!this.inputForm.menuMetadataConfigId){
                        this.inputForm.menuMetadataConfigId = ''
                      }
                        this.$axios(api, this.inputForm, type).then(data => {
                            this.loading = false
                            if (data && data.status) {
                                this.$message.success(data.msg)
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }
                })
            }
        }
    }
</script>
<style>

</style>
